import { useEffect, useRef } from "react";
import styles from "./Designer.module.css";
import { sanitizeColorName } from "../../utils/designerUtils";

const DesignerColorQuickPickerModal = ({
  isOpen = false,
  title = "Elegí un color",
  subtitle = "",
  colors = [],
  selectedColor = null,
  selectedColorId = null,
  onClose,
  onSelectColor,
}) => {
  const interactiveAfterRef = useRef(0);

  useEffect(() => {
    if (!isOpen) return;
    interactiveAfterRef.current = Date.now() + 180;
  }, [isOpen]);

  const canInteract = () => Date.now() >= interactiveAfterRef.current;

  if (!isOpen) return null;

  return (
    <div
      className={styles.colorQuickPickerBackdrop}
      onClick={() => {
        if (!canInteract()) return;
        onClose?.();
      }}
    >
      <div
        className={styles.colorQuickPickerCard}
        onClick={(event) => event.stopPropagation()}
        onPointerDown={(event) => event.stopPropagation()}
      >
        <div className={styles.colorQuickPickerHeader}>
          <div>
            <div className={styles.colorQuickPickerTitle}>{title}</div>
            {subtitle ? <div className={styles.colorQuickPickerSubtitle}>{subtitle}</div> : null}
          </div>
          <button type="button" className={styles.close} onClick={onClose}>Cerrar</button>
        </div>
        <div className={styles.partOptionPaletteSection}>
          <div className={styles.partOptionPaletteHeader}>
            <div className={styles.inputLabel}>Color</div>
            {selectedColor ? (
              <div className={styles.partOptionSelectedColor}>
                <span
                  className={styles.partOptionSelectedColorSwatch}
                  style={{
                    background: selectedColor.code || "linear-gradient(45deg, #eaeaea, #cdcdcd)",
                  }}
                />
                <span>{sanitizeColorName(selectedColor.name, "Color elegido")}</span>
              </div>
            ) : null}
          </div>
          <div className={`${styles.partOptionPaletteGrid} ${styles.colorQuickPickerPaletteGrid}`}>
            {(colors || []).map((color) => {
              const colorId = color?.color_id ?? color?.id ?? null;
              const isSelected = selectedColorId !== null && colorId !== null && String(selectedColorId) === String(colorId);
              return (
                <button
                  key={`quick-color-${colorId ?? color?.name ?? "unknown"}`}
                  type="button"
                  className={`${styles.colorSwatch} ${isSelected ? styles.colorSwatchSelected : ""}`}
                  style={{
                    background: color?.code || "linear-gradient(45deg, #eaeaea, #cdcdcd)",
                  }}
                  onClick={() => {
                    if (!canInteract()) return;
                    onSelectColor?.(color);
                  }}
                  onPointerDown={(event) => event.stopPropagation()}
                  aria-label={`Seleccionar ${sanitizeColorName(color?.name, "color")}`}
                  title={`${sanitizeColorName(color?.name, "Color")} (${color?.code || "sin código"})`}
                />
              );
            })}
          </div>
          <div className={styles.colorQuickPickerHint}>
            Tocá un color para pintarla al toque.
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignerColorQuickPickerModal;
